// EN · TR toggle. Click the inactive label to switch; the active one is
// the brand mint. Small on purpose: header real estate is tight.

import { useT, type Lang } from "../lib/i18n";

const OPTIONS: { code: Lang; label: string }[] = [
  { code: "en", label: "EN" },
  { code: "tr", label: "TR" },
];

export default function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { lang, setLang } = useT();
  return (
    <div className={`a1-lang ${className}`.trim()} role="group" aria-label={lang === "tr" ? "Dil" : "Language"}>
      {OPTIONS.map((opt, i) => (
        <span key={opt.code}>
          <button
            type="button"
            onClick={() => setLang(opt.code)}
            lang={opt.code}
            aria-label={opt.code === "en" ? "English" : "Türkçe"}
            aria-pressed={lang === opt.code}
          >
            {opt.label}
          </button>
          {i < OPTIONS.length - 1 && <span aria-hidden="true">·</span>}
        </span>
      ))}
    </div>
  );
}
